import React from "react";
import { Box, Stack } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress, Typography } from "@mui/material";
import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";

const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
    position: "relative",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
    mb: "1rem",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
  Tabs_01: {
    minHeight: "38px",
    width: "100%",
    "& .MuiTab-root.Mui-selected": {
      background: "#183243",
      color: "#fff",
    },
  },

  tabs: {
    marginRight: "0.4rem",
    color: "#183243",
    textTransform: "none",
    minWidth: "80px",
    minHeight: "1.2rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    maxHeight: "1.2rem",
    lineHeight: "normal",
    background: "#fff",
    borderRadius: "3px",
    border: "1px solid #000000",

    img: {
      margin: "0 !important",
    },
    "&.Mui-selected": {},
    "@media (max-width: 64em)": {},
  },
};

const FallBackUI = ({setQuantityDarwerOpen}) => {
  return (
    <Box sx={classes.drawerBody}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={classes.header}
      >
        <Typography sx={classes.iconDiv}>
          <CloseIcon
            sx={classes.iconn}
            onClick={() => setQuantityDarwerOpen(true)}
          />
        </Typography>
        <Typography color={"black"}>Pricing</Typography>
      </Stack>
      <Box width={"90%"} margin={"auto"}>
        <Box sx={{ textAlign: "center" }}  mt={"8rem"}>
        <CircularProgress size={48}  sx={{ color: "primary.main", mb: 2 }} />
        <Typography variant="body1" color="text.secondary">
          Loading, please wait...
        </Typography>
        </Box>
       
      </Box>
    </Box>
  );
};

export default FallBackUI;
// const FallBackUI = () => {
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "100vh",
//         backgroundColor: "#f9f9f9",
//         padding: 2,
//       }}
//     >
//       <Stack
//         direction="row"
//         alignItems="center"
//         justifyContent="space-between"
//         sx={{
//           width: "100%",
//           maxWidth: "600px",
//           mb: 4,
//         }}
//       >
//         <Box sx={{ cursor: "pointer" }}>
//           <CloseIcon
//             sx={{
//               fontSize: "1.5rem",
//               color: "black",
//             }}
//             // Uncomment the line below and pass the function via props if needed
//             // onClick={() => setCheckoutDrawerOpen(false)}
//           />
//         </Box>
//         <Typography variant="h6" color="text.primary" fontWeight="bold">
//           Pricing
//         </Typography>
//       </Stack>
//       <Box sx={{ textAlign: "center" }}>
//         <CircularProgress size={48} sx={{ color: "primary.main", mb: 2 }} />
//         <Typography variant="body1" color="text.secondary">
//           Loading, please wait...
//         </Typography>
//       </Box>
//     </Box>
//   );
// };
